import MuiSnackbar, { SnackbarProps as Props } from '@material-ui/core/Snackbar'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

export type SnackbarProps = Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      ...theme.typography.body2,
      background: theme.palette.common.black,
      padding: theme.spacing(1),
      '& .MuiSnackbarContent-root': {
        background: theme.palette.common.black
      }
    }
  })
)

const Snackbar: React.FC<SnackbarProps> = (props) => {
  const classes = useStyles(props)
  const { children, open, message, ...rest } = props
  return (
    <div>
      {children}
      <MuiSnackbar
        className={classes.root}
        open={open}
        message={message}
        {...rest}
      />
    </div>
  )
}

export default Snackbar
